export default {
  loanCollateralTable: 'https://docs.ooki.com/protocol/borrow/liquidation',
  ookiCoingecko: 'https://www.coingecko.com/en/coins/ooki',
  buyOoki: {
    sushiswapEthereum: {
      title: 'Sushiswap Ethereum',
      icon: 'sushiswap',
      url: 'https://app.sushi.com/swap?inputCurrency=USDT&outputCurrency=0x0de05f6447ab4d22c8827449ee4ba2d5c288379b',
      color: '',
    },
    sushiswapPolygon: {
      title: 'Sushiswap Polygon',
      icon: 'sushiswap',
      url: 'https://app.sushi.com/swap?inputCurrency=MATIC&outputCurrency=0xCd150B1F528F326f5194c012f32Eb30135C7C2c9',
      color: '',
    },
    mexcGlobal: {
      title: 'MEXC Global',
      icon: 'mexcglobal',
      url: 'https://www.mexc.com/exchange/OOKI_USDT',
      color: '',
    },
    gateIO: {
      title: 'Gate.io',
      icon: 'gateio',
      url: 'https://www.gate.io/trade/OOKI_USDT',
      color: '',
    },
    binance: {
      title: 'Binance',
      icon: 'binance-logo',
      url: 'https://www.binance.com/en/price/ooki-protocol?ref=368715348',
      color: '#f3ba2e',
    },
    wazirX: {
      title: 'WazirX',
      icon: 'wazirx',
      url: 'https://wazirx.com/exchange/OOKI-USDT',
      color: '',
    },
  },
  videos: {
    // shown in the lobby; playlist updated by marketing - broken until replacement in the new channel
    ookiPromo: 'https://www.youtube.com/embed/videoseries?list=PL1EtznDVa1f37c96CFpaVxjV1pGmJnbu0',
  },
  docs: {
    daoGovernance: 'https://docs.ooki.com/governance/dao-governance',
    staking: 'https://docs.ooki.com/protocol/stake',
    voteDelegation: 'https://docs.ooki.com/governance/delegating',
  },
  articles: {
    ookiMigration: 'https://blog.ooki.com/ooki-launch-stage-three-ooki-token',
    ookiv2: 'https://blog.ooki.com/ooki-version-2-0/',
    itokens: 'https://blog.ooki.com/ookiversity-what-are-itokens/',
    dexSelectorRelease: 'https://blog.ooki.com/ooki-updates-dex-selector-optimism-and-more/',
  },
  socials: {
    discord: {
      title: 'Discord',
      icon: 'discord',
      url: 'https://discord.gg/4wPVA6a',
      external: true,
    },

    facebook: {
      title: 'Facebook',
      icon: 'Facebook',
      url: 'https://facebook.com/ookitrade',
      external: true,
    },

    instagram: {
      title: 'Instagram',
      icon: 'Instagram',
      url: 'https://www.instagram.com/ookitrade/',
      external: true,
    },

    twitter: {
      title: 'Twitter',
      icon: 'twitter',
      url: 'https://twitter.com/intent/follow?screen_name=OokiTrade',
      external: true,
    },

    telegram: {
      title: 'Telegram Talk',
      icon: 'telegram',
      url: 'https://t.me/OokiTrade',
      external: true,
    },

    telegramAnnouncement: {
      title: 'Announcements',
      icon: 'ooki-black-white',
      url: 'https://t.me/OokiAnnouncements',
      external: true,
    },

    youtube: {
      title: 'Youtube',
      icon: 'Youtube',
      url: 'https://www.youtube.com/@ookidex',
      external: true,
    },
  },

  cryptoPlatforms: [
    {
      title: 'Coingecko',
      icon: 'coingecko',
      url: 'https://www.coingecko.com/en/coins/ooki',
      external: true,
    },
    {
      title: 'Coinmarketcap',
      icon: 'coinmarketcap',
      url: 'https://coinmarketcap.com/currencies/ooki-protocol/',
      external: true,
    },
    {
      title: 'Coinbase',
      icon: 'coinbase',
      url: 'https://www.coinbase.com/price/ooki-protocol',
      external: true,
    },
    {
      title: 'Crypto.com',
      icon: 'crypto-com',
      url: 'https://crypto.com/price/ooki-protocol',
      external: true,
    },
    {
      title: 'Coinpaprika',
      icon: 'coinpaprika',
      url: 'https://coinpaprika.com/coin/ooki-ooki/',
      external: true,
    },
    {
      title: 'Coincarp',
      icon: 'coincarp',
      url: 'https://www.coincarp.com/currencies/ooki-token/',
      external: true,
    },
  ],
  daoTreasury: 'https://etherscan.io/address/0xfedc4dd5247b93feb41e899a09c44cfabec29cbc',
  daoSnapshot: 'https://snapshot.org/#/ooki.eth',
  tally: 'https://www.tally.xyz/governance/eip155:1:0x3133b4F4dcffc083724435784fEFAD510FA659c6',
  blog: {
    title: 'OOKI Blog',
    icon: 'token-ooki',
    url: 'https://blog.ooki.com',
    external: true,
  },
  shop: 'https://shop.ooki.com',
  gitbook: 'https://docs.ooki.com',
  ookiversity: 'https://blog.ooki.com/tag/ookiversity/',
  forum: 'https://forum.ooki.com/',
  nfts: 'https://opensea.io/collection/ooki',
  github: {
    title: 'Github',
    icon: 'github',
    url: 'https://github.com/OokiTrade',
    external: true,
  },
  daoProposalsGithub:
    'https://github.com/OokiTrade/contractsV2/tree/development/scripts/dao-proposals',
  compensationChannel: 'https://t.me/bzxcompensation',
}
